module.exports = __webpack_public_path__ + "static/media/error2.c94bffd0.wav";